<script>
    import {isNOU} from "@/assets/plugins/mps-common/expansions/condition";

    export default {
        name: "VueDataTableFunctions",
        methods: {
            isNOU(v) {
                return v === null || v === undefined;
            },

            /**
             * 오브젝트에서 키에 해당하는 값을 가져옵니다. 해당하는 키가 없을 경우 null 을 반환합니다.
             *
             * @param o 객체
             * @param s 키
             * @returns {null|*} null 또는 해당하는 키의 값
             */
            byString(o, s) {
                if (!s) return null;
                s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                s = s.replace(/^\./, '');           // strip a leading dot
                let a = s.split('.');
                for (let i = 0, n = a.length; i < n; ++i) {
                    let k = a[i];
                    if (!this.isNOU(o[k]) && k in o) {
                        o = o[k];
                    } else {
                        return null;
                    }
                }
                return o;
            },

            /**
             * 오브젝트에서 키에 해당하는 곳에 값을 대입합니다. 해당하는 키가 없을 경우 아무것도 하지 않습니다.
             *
             * @param o 객체
             * @param s 키
             * @param v 값
             */
            assign(o, s, v) {
                if (!s) return null;
                s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                s = s.replace(/^\./, '');           // strip a leading dot
                let a = s.split('.');
                for (let i = 0, n = a.length; i < n; ++i) {
                    let k = a[i];
                    if (k in o) {
                        if (i < (n - 1)) {
                            o = o[k];
                        } else {
                            o[k] = v;
                            o = o[k];
                        }
                    } else {
                        return null;
                    }
                }
                return o;
            },

            isEmpty(v) {
                return isNOU(v) || !Array.isArray(v) || v.length === 0;
            },
        },
    }
</script>